import { NgModule } from '@angular/core';
import { SaysuaCommonModule } from 'framework/common.module';
import { StaffComponent } from './staff.component';
import { HomeComponent } from './home/home.component';
import { TestComponent } from './test/test.component';

@NgModule({
    imports: [
        SaysuaCommonModule
    ],
    exports: [],
    declarations: [
        StaffComponent,
        HomeComponent,
        TestComponent
    ],
    providers: [],
})
export class StaffModule { }
